import dayjs from 'dayjs'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import { connect } from 'react-redux'
import { getWaiter } from 'redux-waiter'
import { BENEFIT_TYPE_DENTAL, BENEFIT_TYPE_HEALTH, BENEFIT_TYPE_VISION } from '@hixme/benefit-types'
import { selectors as userSessionSelectors, constants, actions } from 'store/modules/user-session'
import * as cartSelectors from 'store/modules/cart/selectors'
import * as personSelectors from 'store/modules/persons/selectors'
import { Home } from '../components'

dayjs.extend(isSameOrBefore)

const mapStateToProps = (state) => {
  const { Benefits } = getWaiter(state, `${constants.GET_USER_BENEFITS}_`).response || {}
  const isQLEAvailable =
    Benefits &&
    Benefits.find((benefit) => {
      return (
        [BENEFIT_TYPE_DENTAL, BENEFIT_TYPE_HEALTH, BENEFIT_TYPE_VISION].includes(
          benefit.BenefitType
        ) && dayjs().isSameOrBefore(benefit.BenefitEndDate, 'day')
      )
    })

  // This is used for opt-out banner to determine who to additionally call
  // declineMedicare mutation since this mutation is not idempotent.
  // It will error trying to decline an already declined member
  const medicareBenefits = cartSelectors.getAllMedicareBenefits(state)
  const personsEnrolledInMedicare = medicareBenefits.map((benefit) => benefit.Persons).flat()

  return {
    enrollmentInfo: userSessionSelectors.getEnrollmentInfoSelector(state),
    hasNeverSawProviderQuestion:
      userSessionSelectors.hasSeenProviderLookupQuestion(state) === undefined,
    benefits: userSessionSelectors.getClientBenefitsSummary(state),
    enrollmentComplete: userSessionSelectors.getEnrollmentCompleteSelector(state),
    isCartCommitted: userSessionSelectors.isCartCommitted(state),
    person: personSelectors.getPersonSelector(state),
    enrollmentResponses: userSessionSelectors.getEnrollmentResponses(state),
    dentalComplete: cartSelectors.dentalBenefitComplete(state),
    visionComplete: cartSelectors.visionBenefitComplete(state),
    healthComplete: cartSelectors.healthBenefitComplete(state),
    groupComplete: cartSelectors.groupHealthBenefitComplete(state),
    additionalBenefitsComplete: cartSelectors.additionalBenefitsComplete(state),
    needsToSignHealthBundles: cartSelectors.needsToSignHealthBundles(state),
    isGuestUser: userSessionSelectors.isGuestUser(state),
    hasHealthBundleBenefit: userSessionSelectors.healthBundleBenefitIsAvailable(state),
    isExistingMember: userSessionSelectors.getPreviousEnrollment(state) !== undefined,
    isICHRAAvailable: userSessionSelectors.getICHRAAvailablity(state) || false,
    isEnrolling: userSessionSelectors.isEnrolling(state),
    isQLEAvailable: isQLEAvailable,
    enrollmentSession: userSessionSelectors.getEnrollmentSession(state),
    prevEnrollment: userSessionSelectors.getPreviousEnrollment(state),
    personsEnrolledInMedicare,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getCutoffTime: (cutoffTime) => {
      dispatch(actions.getEnrollmentCutoffTime(cutoffTime))
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Home)
